export default "__VITE_ASSET__BHkhNnDX__"